import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const stars = '⭐⭐⭐⭐⭐';
  const testimonials = [{
    size: 'large',
    name: 'Leticia M., 46 años',
    location: 'San Antonio, Texas',
    quote: 'Llevaba 2 años intentando bajar la panza. Con el Protocolo Reinicio 40+ entendí por primera vez POR QUÉ mi cuerpo no respondía. En la semana 2 ya dormía mejor y los antojos simplemente desaparecieron. En el día 21 mi ropa volvió a cerrarme.',
    initials: 'LM'
  }, {
    size: 'large',
    name: 'Carmen R., 52 años',
    location: 'Ciudad de México',
    quote: 'Lo que más me gustó fue que no tuve que dejar mi comida. Sigo comiendo mis frijoles, mis tortillas, mi café. Solo cambié el orden y los horarios. Mi cintura bajó 6 cm en un mes sin morirme de hambre ni una sola vez.',
    initials: 'CR'
  }, {
    size: 'small',
    name: 'Elena V., 43 años',
    location: 'Miami, Florida',
    quote: 'Lo compré porque costaba menos que un café de Starbucks. Lo que NO esperaba era que me cambiaría la forma en que entiendo mi cuerpo para siempre.',
    initials: 'EV'
  }, {
    size: 'small',
    name: 'Marisol G., 49 años',
    location: 'Monterrey, México',
    quote: 'Soy mamá de tres hijos y trabajo desde casa. El plan de comidas de 15 minutos me cambió la vida. Bajé 4 kilos en el primer mes.',
    initials: 'MG'
  }, {
    size: 'small',
    name: 'Adriana P., 55 años',
    location: 'Los Ángeles, California',
    quote: 'Dejar de obsesionarme con la báscula y medir mis bioseñales me dio una perspectiva completamente diferente. En semana 3 mi promedio subió de 4 a 8.',
    initials: 'AP'
  }];
  const TestimonialCard = ({
    t
  }: {
    t: any;
  }) => <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-white rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)] p-6 md:p-7 flex flex-col h-full" data-id="element-282">
      <div className="text-[14px] mb-4 tracking-widest" data-id="element-283">{stars}</div>
      <div className="relative flex-grow mb-6" data-id="element-284">
        <span className="absolute -top-4 -left-2 text-[48px] text-teal opacity-20 font-serif leading-none" data-id="element-285">
          "
        </span>
        <p className="text-[16px] italic text-[#333] leading-[1.8] relative z-10 pt-2" data-id="element-286">
          {t.quote}
        </p>
      </div>
      <div className="border-t border-gray-100 pt-4 flex items-center gap-4 mt-auto" data-id="element-287">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal to-teal-dark flex items-center justify-center text-white font-bold flex-shrink-0" data-id="element-288">
          {t.initials}
        </div>
        <div className="flex-grow" data-id="element-289">
          <div className="font-bold text-[15px] text-dark" data-id="element-290">{t.name}</div>
          <div className="text-[13px] text-teal" data-id="element-291">{t.location}</div>
        </div>
        <div className="hidden sm:block bg-green-100 text-green-800 text-[10px] font-bold px-2 py-1 rounded-full whitespace-nowrap" data-id="element-292">
          Compradora Verificada ✓
        </div>
      </div>
    </motion.div>;
  return <section className="w-full bg-lightGray py-20 px-4" data-id="element-293">
      <div className="max-w-[1000px] mx-auto" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-295">
          <h2 className="text-[28px] md:text-[32px] font-bold text-dark mb-3" data-id="element-296">
            Lo Que Dicen las Mujeres que Ya Lo Están Viviendo:
          </h2>
          <div className="text-[18px] tracking-widest" data-id="element-297">{stars}</div>
        </motion.div>

        <div className="flex flex-col gap-6" data-id="element-298">
          {/* Top Row - Large Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-299">
            {testimonials.filter(t => t.size === 'large').map((t, i) => <TestimonialCard key={i} t={t} data-id="element-300" />)}
          </div>

          {/* Bottom Row - Small Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-301">
            {testimonials.filter(t => t.size === 'small').map((t, i) => <TestimonialCard key={i} t={t} data-id="element-302" />)}
          </div>
        </div>
      </div>
    </section>;
}